<template>
  <transition name="typing-fade">
    <div v-if="isVisible" class="typing-indicator">
      <div class="typing-indicator__bubble">
        <span class="typing-indicator__text">El visitante está escribiendo</span>
        <span class="typing-indicator__dots">
          <span class="typing-indicator__dot"></span>
          <span class="typing-indicator__dot"></span>
          <span class="typing-indicator__dot"></span>
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VisitorTypingIndicator",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="sass" scoped>
.typing-indicator
  display: flex
  justify-content: flex-start
  padding: 6px 16px
  width: 100%

.typing-indicator__bubble
  display: inline-flex
  align-items: center
  gap: 8px
  padding: 8px 14px
  background-color: #ffffff
  border-radius: 12px 12px 12px 2px
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08)
  border: 1px solid rgba(0, 0, 0, 0.04)

.typing-indicator__text
  font-size: 12px
  font-weight: 500
  color: #595959

.typing-indicator__dots
  display: inline-flex
  align-items: center
  gap: 3px

.typing-indicator__dot
  width: 5px
  height: 5px
  border-radius: 50%
  background-color: #1890ff
  animation: typing-bounce 1.4s infinite ease-in-out

  &:nth-child(1)
    animation-delay: 0s

  &:nth-child(2)
    animation-delay: 0.2s

  &:nth-child(3)
    animation-delay: 0.4s

@keyframes typing-bounce
  0%, 80%, 100%
    opacity: 0.3
    transform: translateY(0) scale(0.85)

  40%
    opacity: 1
    transform: translateY(-3px) scale(1.1)

.typing-fade-enter-active,
.typing-fade-leave-active
  transition: all 0.25s ease

.typing-fade-enter-from,
.typing-fade-leave-to
  opacity: 0
  transform: translateY(6px)
</style>
